
import { MaterialPrefix } from "@/types/slab";
import { PriceCategory } from "@/types/priceCategory";

export function generateSlabCode(
  type: string | undefined, 
  price: number, 
  pricePerSqft: number,
  materialPrefixes: MaterialPrefix[],
  priceCategories: PriceCategory[]
): string {
  // 1. Encontrar o prefixo do material
  const materialPrefix = materialPrefixes?.find(mp => 
    mp.material_type?.toLowerCase() === type?.toLowerCase()
  );

  console.log('Material Prefix Match:', {
    type,
    materialPrefixes: materialPrefixes?.map(mp => ({
      type: mp.material_type,
      prefix: mp.prefix
    })),
    found: materialPrefix
  });
  
  // Usar o prefixo encontrado ou 'OTH' como fallback
  const typePrefix = materialPrefix?.prefix || 'OTH';

  // 2. Usar o preço inteiro (sem decimais)
  const wholePrice = Math.floor(price || 0);
  const wholePricePerSqft = Math.floor(pricePerSqft || 0);

  // 3. Símbolo "#" como separador
  const separator = '#';

  // 4. Encontrar o prefixo da categoria de preço
  const priceCategory = priceCategories?.find(pc => {
    if (pc?.price_type === 'fixed') {
      return pc.fixed_price === price;
    } else {
      return price >= (pc?.min_price || 0) && price <= (pc?.max_price || Infinity);
    }
  });

  console.log('Price Category Match:', {
    price,
    priceCategories: priceCategories?.map(pc => ({
      name: pc.name,
      prefix: pc.prefix,
      price_type: pc.price_type,
      fixed_price: pc.fixed_price,
      min_price: pc.min_price,
      max_price: pc.max_price
    })),
    found: priceCategory
  });

  // Usar o prefixo do grupo de preço apenas se ele existir e não estiver vazio
  const categoryPrefix = priceCategory?.prefix?.trim() 
    ? priceCategory.prefix.trim() 
    : 'W';

  // Montar o código final: prefixoMaterial + preço + "#" + preçoSQFT + prefixoGrupoPreço
  const code = `${typePrefix}${wholePrice}${separator}${wholePricePerSqft}${categoryPrefix}`;
  
  console.log('Generated Code:', {
    typePrefix,
    wholePrice,
    separator,
    wholePricePerSqft,
    categoryPrefix,
    finalCode: code
  });

  return code;
}
